import { Button } from '@mui/material'
import { SvgAsset } from '~/components/SvgAsset'
import { Colors } from '~/libs/mui/theme'

interface SubmitButtonProps {
  /** 送信ボタンの非活性 */
  isSubmittable: boolean
}

export function SubmitButton({ isSubmittable }: SubmitButtonProps): JSX.Element {
  return (
    <Button
      type='submit'
      variant='contained'
      sx={{
        width: 42,
        minWidth: 42,
        height: 34,
        minHeight: 34,
        color: Colors.yellow,
        backgroundColor: Colors.color1A1A18,
      }}
      disabled={!isSubmittable}
    >
      <SvgAsset asset='comment' sx={{ color: Colors.yellow }} />
    </Button>
  )
}
